import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoanService } from '../../shared-component/service/loan/loan.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  public tokenId: string;
  public loanDetail: any = {};
  public isConnected = true;

  constructor(
    public router: Router,
    public activeRoute: ActivatedRoute,
    public loanService: LoanService
  ) {
  }

  ngOnInit() {
    this.activeRoute.data.subscribe(res => {
      this.loanDetail = res.loanDetail;
      this.tokenId = this.loanDetail.token;
    });
    if (this.loanDetail && this.loanDetail.Customer && this.loanDetail.Customer.DigioEkycRequest && this.loanDetail.Customer.DigioEkycRequest.videoVerificationRequestId) {
      this.loanService.updateEkycResponse(this.tokenId, {});
    }
  }

  goNext() {
    this.router.navigateByUrl(`/loan/process/${this.tokenId}/register`, {replaceUrl: true});
  }

  skipped() {
    this.loanService.signup({ skipRegister: true }, this.tokenId).subscribe((res: any) => {
        let LeadredirectionUrl = res.data.Lead ? res.data.Lead.redirectionUrl : "";
        if (LeadredirectionUrl) {
            if (!LeadredirectionUrl.startsWith('http://') && !LeadredirectionUrl.startsWith('https://')) {
                LeadredirectionUrl = 'https://' + LeadredirectionUrl;
            }
            window.location.href = LeadredirectionUrl;
        } else {
            this.router.navigateByUrl(`/loan/process/${this.tokenId}/status`, { replaceUrl: true });
        }
    });
}
}
